import { useEffect, useState } from 'react';

// The voice and chat assistant (Tyvane, the "TowerGPS Support" service). Its
// script is loaded once, with Tyvane's own floating button turned off: the
// assistant is opened from our buttons instead (the map's control column, the
// left menu on Settings and Reports, the top bar on phones), so nothing covers
// the map controls, the "+" button or the bottom menu.

const KEY = 'pk_mEUwt6tuAyJA9tN4UjpK66dC'; // public: the key only works on track.towergps.com
const SRC = 'https://tyvane.com/support.js';

let loading = null;

export const loadAssistant = () => {
  if (loading) return loading;
  loading = new Promise((resolve) => {
    if (window.Tyvane?.open) {
      resolve(window.Tyvane);
      return;
    }
    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    script.dataset.key = KEY;
    script.dataset.launcher = 'none';
    script.dataset.label = 'Support';
    // on phones the conversation panel sits above the bottom menu
    script.dataset.bottom = window.matchMedia('(max-width: 899px)').matches ? '76' : '20';
    script.onload = () => resolve(window.Tyvane);
    script.onerror = () => {
      loading = null;
      resolve(null);
    };
    document.body.appendChild(script);
  });
  return loading;
};

// kind: 'voice' or 'text'. Asking for the other kind during a conversation switches to it.
export const openAssistant = (kind) => loadAssistant().then((tyvane) => {
  if (!tyvane) return;
  if (kind === 'text') tyvane.chat();
  else tyvane.open(null, { mode: 'voice' });
});

// Whether a conversation is on, and which kind, to light up the buttons.
let lastState = { active: false, kind: null, open: false };
document.addEventListener('tyvane:state', (e) => {
  lastState = e.detail || lastState;
});

export const useAssistantState = () => {
  const [state, setState] = useState(lastState);
  useEffect(() => {
    const onState = (e) => setState(e.detail || lastState);
    document.addEventListener('tyvane:state', onState);
    return () => document.removeEventListener('tyvane:state', onState);
  }, []);
  return state;
};

export const assistantRole = (user) => {
  if (user.administrator) return 'Administrator';
  if (user.recovery) return 'Recovery agent';
  return 'Company user';
};
